module.exports = __webpack_public_path__ + "img/RoundTelegram.94fac0fa.png";